/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { BarredLocationEntity } from './barred-location-entity';
import { CandidateEntity } from './candidate-entity';
export class CandidatesBarredLocationEntity extends Entity {
  barredLocation: BarredLocationEntity | null = null;
  barredLocationId: string | null = null;
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  updatedAt: string | null = null;
  static override key = 'CandidatesBarredLocation';
  static override get schema() {
    return {
      barredLocation: BarredLocationEntity,
      candidate: CandidateEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidatesBarredLocation' in input
    ) {
      const { CandidatesBarredLocation: wrapped, ...rest } = input as {
        CandidatesBarredLocation: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}